"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactPose = _interopRequireDefault(require("react-pose"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenConstants = require("@8x8/oxygen-constants");

var _getBackgroundColor = _interopRequireDefault(require("./utils/getBackgroundColor"));

var _getColor = _interopRequireDefault(require("./utils/getColor"));

var _getWidth = _interopRequireDefault(require("./utils/getWidth"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var toastContainerAnimationProps = {
  enter: {
    opacity: 1,
    transition: {
      duration: (0, _oxygenConfig.getById)('toast').animationEnterDuration,
      ease: (0, _oxygenConfig.getById)('toast').animationEnterTimingFunction
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: (0, _oxygenConfig.getById)('toast').animationExitDuration,
      ease: (0, _oxygenConfig.getById)('toast').animationExitTimingFunction
    }
  },
  flip: {
    transition: {
      type: 'tween',
      duration: (0, _oxygenConfig.getById)('toast').animationFlipDuration
    }
  }
};
var ToastContainer = (0, _styledComponents["default"])(_reactPose["default"].div(toastContainerAnimationProps)).attrs(function (_ref) {
  var type = _ref.type;
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)(type === _oxygenConstants.toastTypes.error ? 'TOAST_ERROR_CONTAINER' : 'TOAST_SUCCESS_CONTAINER'));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  color: ", ";\n  display: flex;\n  font-family: ", ";\n  font-size: ", ";\n  font-stretch: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  text-align: ", ";\n  padding: ", ";\n  ", "\n  max-height: ", ";\n  max-width: ", ";\n"])), _getBackgroundColor["default"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow;
}, _getColor["default"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontStretch;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontStyle;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.letterSpacing;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.textAlign;
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.paddingY, " ").concat(theme.paddingX);
}, _getWidth["default"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.maxHeight;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.maxWidth;
});
var _default = ToastContainer;
exports["default"] = _default;